import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import type { SupportFilterSchema } from './filter-schema';
import { supportFilterSchema } from './filter-schema';
import { filterDefaultValues } from './model';

export function useFilterFormDefinition(initialValues?: SupportFilterSchema) {
  return useForm({
    resolver: zodResolver(supportFilterSchema),
    defaultValues: { ...filterDefaultValues, ...(initialValues || {}) },
  });
}
